export default __webpack_public_path__ + "static/img3-24ab78b55ca6085127fb4cbdea4718b6.png";